/** Production constants **/
export const CDN_HOST = 'https://dye1vg6h1p5m0.cloudfront.net/';
export const CDN_ASSET_HOST_PRODUCTION = 'https://cdn.kaboodle.co.uk';
export const CDN_ASSET_HOST_STAGING = 'https://staging-cdn.kaboodle.co.uk';

export default { CDN_HOST, CDN_ASSET_HOST_PRODUCTION, CDN_ASSET_HOST_STAGING };
